import {
    blackColor, eventNameColor, boxShadow,
} from '../global';

const grandBooth = (theme) => ({
    noPadding: {
        padding: 0,
    },
    btnStyle: {
        fontSize: 14,
        minWidth: '100px',
        margin: '10px',
    },
    buttonBig: {
        fontSize: '30px !important',
        minWidth: '250px !important',
        padding: '10px !important',
        margin: '30px !important',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '150px !important',
            margin: '10px  !important',
        },
    },
    btnShowCompanyInfo: {
        fontSize: '24px',
        borderRadius: '18px',
        fontWeight: 'bold',
        boxShadow: 'none',
        border: `2px solid ${blackColor}`,
        marginBottom: '36px',
        padding: '10px 25px',
    },
    productItem: {
        marginBottom: '1rem',
        boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.5)',
        backgroundColor: '#fff',
        cursor: 'pointer',
    },
    productPrice: {
        position: 'relative',
        fontWeight: 'bold',
        wordWrap: 'break-word',
        color: (props) => props?.customColorExhibitor?.contents_text_color,
    },
    productThumbnail: {
        position: 'relative',
        display: 'block',
        overflow: 'hidden',
        cursor: 'pointer',
        border: '1px solid rgba(0,0,0,0.2)',

        '&:before': {
            display: 'block',
            paddingTop: '75%',
            content: '" "',
        },
    },
    productItemImg: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    productMeta: {
        padding: '5px',
    },
    productItemNameWrapper: {
        height: '50px',
        fontSize: '14px',
    },
    productItemName: {
        display: '-webkit-box',
        overflow: 'hidden',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        fontWeight: 'normal',
        margin: 0,
        fontSize: '14px',
        padding: '0 16px',
        color: (props) => props?.customColorExhibitor?.contents_text_color,
    },
    productItemIcon: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '1',
    },
    backLink: {
        paddingBottom: '10px',
        color: (props) => props?.customColorExhibitor?.event_name_text_color || eventNameColor,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        fontSize: '20px',

        '&:focus': {
            outline: 0,
        },
    },
    layoutFirstProduct: {
        marginBottom: '1rem',
        backgroundColor: '#fff',
        cursor: 'pointer',
        maxWidth: '280px',
        margin: 'auto',

        '&:hover': {
            transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
            ...boxShadow,
        },
    },
    layoutFirstProductThumbnail: {
        position: 'relative',
        display: 'block',
        overflow: 'hidden',
        cursor: 'pointer',
        border: '0.5px solid #f0f0f0',
        maxWidth: '280px',
        maxHeight: '280px',

        '&:before': {
            display: 'block',
            paddingTop: '100%',
            content: '" "',
        },
    },
    layoutFirstItem: {
        [theme.breakpoints.up('sm')]: {
            padding: '0 30px 40px 30px',
        },
    },
    layoutFirstProductItem: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: '50%',
    },
    layoutFirstProductName: {
        padding: '10px 0 5px 0',
    },
    layoutFirstProductItemName: {
        display: '-webkit-box',
        overflow: 'hidden',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        fontWeight: 'normal',
        margin: 0,
        fontSize: '14px',
        color: (props) => props?.customColorExhibitor?.contents_text_color,
        height: '40px',
    },
    layoutFirstProductMeta: {
        padding: '5px 5px 10px 5px',
    },
    layoutFirstProductItemIcon: {
        position: 'absolute',
        right: '1%',
        bottom: '-1%',
        zIndex: '1',
        margin: '0px',
    },
    productSliderArrow: {
        position: 'fixed',
        top: '45%',
        left: '10%',
        cursor: 'pointer',
        margin: '0px',
    },
    productSliderArrowMobile: {
        position: 'fixed',
        top: '45%',
        left: '-3%',
        cursor: 'pointer',
        margin: '0px',
    },
    productSliderArrowDisable: {
        position: 'fixed',
        top: '45%',
        left: '10%',
        cursor: 'default',
        margin: '0px',
        opacity: '0.3',
    },
    productSliderArrowDisableMobile: {
        position: 'fixed',
        top: '45%',
        left: '-3%',
        cursor: 'default',
        margin: '0px',
        opacity: '0.3',
    },
    productSliderNextArrow: {
        position: 'fixed',
        top: '45%',
        right: '10%',
        cursor: 'pointer',
        margin: '0px',
    },
    productSliderNextArrowMobile: {
        position: 'fixed',
        top: '45%',
        right: '-3%',
        cursor: 'pointer',
        margin: '0px',
    },
    productSliderNextArrowDisable: {
        position: 'fixed',
        top: '45%',
        right: '10%',
        cursor: 'default',
        margin: '0px',
        opacity: '0.3',
    },
    productSliderNextArrowDisableMobile: {
        position: 'fixed',
        top: '45%',
        right: '-3%',
        cursor: 'default',
        margin: '0px',
        opacity: '0.3',
    },
    rootLayout: {
        zIndex: '10000 !important',
        '& > div > .MuiPaper-root': {
            backgroundColor: 'transparent',
        },
        '& > div > .MuiPaper-elevation24': {
            boxShadow: 'none',
            maxWidth: '645px',
            maxHeight: '700px',
            margin: 0,
            padding: '32px',
        },
    },
    imgStyle: {
        display: 'block',
        maxWidth: '100%',
        maxHeight: '500px',
        margin: 'auto',
    },
    productSliderInfoProduct: {
        display: 'flex',
        justifyContent: 'center',
        color: 'white',
        fontSize: '16px',
    },
    productSliderInfoProductName: {
        display: '-webkit-box',
        overflow: 'hidden',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        maxWidth: '200px',
        marginRight: '10px',
    },
    sliderFirst: {
        '& > div': {
            height: '100% !important',
        },
    },
    CloseBtn: {
        top: '-3px',
        right: 0,
        padding: 0,
        position: 'absolute',
    },
});

export default grandBooth;
